import { render, staticRenderFns } from "./ReportsMatchView.vue?vue&type=template&id=5bdadc79&scoped=true&"
import script from "./ReportsMatchView.vue?vue&type=script&lang=js&"
export * from "./ReportsMatchView.vue?vue&type=script&lang=js&"
import style0 from "./ReportsMatchView.vue?vue&type=style&index=0&id=5bdadc79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdadc79",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VTab,
  VTabs,
  VToolbar,
})
